export const reverseReportList = ['诈骗电话', '违法电话', '骚扰电话', '其他高风险电话'];

export const moreServiceList = [
    {
        text: '核酸检测机构',
        type: 'hesuan',
        auth: ['hesuan'],
        color: 'blue'
    },
    {
        text: '12321投诉',
        type: 'mark',
        auth: ['location', 'reports']
    },
    {
        text: '12321投诉',
        type: 'noNumMark',
        auth: ['noNumCustom']
    },
    {
        // 只针对无号码卡，会跳转之前的反馈页面
        text: '号码申诉反馈',
        type: 'noNumFeedback',
        auth: ['noNumCustom']
    },
    {
        text: '号码申诉反馈',
        type: 'appeal',
        auth: ['reports', 'custom']
    },
    {
        text: '企业号码认证',
        type: 'attest',
        auth: ['noNumCustom', 'custom', 'reports', 'location']
    },
];